import { Helmet } from 'react-helmet-async';
import { Container, Grid } from '@mui/material';
import CustomBreadcrumbs from '@/commons/custom-breadcrumbs';
import { useAuthContext } from '@/hooks/useAuthContext';
import Loader from '@/commons/loader';
import {CardBackground} from "@commons/card-background/CardBackground";
import {useSelectBranch} from "@hooks/useSelectBranch";
import { EmptyBranch } from './empty-branch';

export default function BranchSelectPage() {
  const { user } = useAuthContext();
  const {mutateAsync, isPending} = useSelectBranch();

  if (isPending) {
    return <Loader fullScreen />;
  }
  return (
    <>
      <Helmet>
        <title> {import.meta.env.VITE_TITLE_BUSINESS}: List branches </title>
      </Helmet>


      {user?.branches?.length ? (  
      <Container
        sx={{
          maxWidth: {
            md: 700,
            xs: 400,
          },
        }}
        >
        <CustomBreadcrumbs heading="branch" links={[]} />
        <Grid container spacing={3}>
        {user?.branches?.map?.((branch) => (
          <Grid item xs={6} key={branch.id}>
          <CardBackground data={branch} onClick={mutateAsync} />
          </Grid>
          ))}
          </Grid>
        </Container>
      ) : ( 
        <EmptyBranch/>
        )}
    </>
  );
}
